import { Carousel } from 'components/Carousels'
import { memo, useMemo } from 'react'
import { trustMarkersTypes } from './constants'
import { ItemComponentCarousel } from './ItemComponentCarousel'
import { TrustpilotCard } from './TrustpilotCard'
import { withUuid } from '@/utils/shared'

const TrustMarkersCarousel = memo(({ trustMarkers, items }) => {
  const trustMarkersWithUuid = useMemo(() => withUuid(trustMarkers), [trustMarkers])

  return (
    <div className={`relative sm:mt-2 mr-8 mt-12 sm:mr-0`}>
      {trustMarkersWithUuid.map((marker) => {
        return (
          <TrustpilotCard
            key={marker?.uuid}
            type={trustMarkersTypes[marker?.jsonContent?.company]}
            trustMarker={marker?.jsonContent}
          />
        )
      })}
      <div className="relative">
        <Carousel
          autoPlay={true}
          carouselItems={items}
          itemComponent={ItemComponentCarousel}
          variant="preview-full"
          withIndicators={items?.length > 1}
          disableArrows={true}
          classNameIndicatorDots="flex bg-[#3300ff] mt-8 mb-8 lg:hidden hover:cursor-pointer"
          idPrefix="hero-slider"
          interval={10000}
          navigateOnClick={true}
          scrollOnChange={false}
          classNameContainer="max-w-[509px] lg:max-w-none "
          className="p-0"
        />
      </div>
    </div>
  )
})
TrustMarkersCarousel.displayName = 'TrustMarkersCarousel'

export { TrustMarkersCarousel }
